import { AppConsts } from '@shared/AppConsts';
import { IThemeAssetContributor } from '../ThemeAssetContributor';

export class Theme2ThemeAssetContributor implements IThemeAssetContributor {
    getAssetUrls(): string[] {
        //return [AppConsts.appBaseUrl + '/assets/fonts/fonts-asap-condensed.min.css'];
        return [AppConsts.appBaseUrl + '/assets/fonts/fonts-asap-condensed.css'];
    }
}
